import request from '@/utils/request'

// crm 自定義欄位的新增
/**
 *
 * @param {*} data
 * 操作方法 (save:新增、update:編輯、read:詳情、index:列表)
 * 操作ID (如：客戶ID)
 */
export function filedGetField(data) {
  return request({
    url: 'admin/field/getField',
    method: 'post',
    data: data
  })
}

// crm 自定義欄位驗重
export function filedValidates(data) {
  return request({
    url: 'admin/field/validates',
    method: 'post',
    data: data
  })
}

// crm 自定義欄位(高級篩選)
export function filterIndexfields(data) {
  return request({
    url: 'admin/index/fields',
    method: 'post',
    data: data
  })
}

// 商機狀態組列表 systemCustomer.js 也包含該介面
export function businessGroupList(data) {
  return request({
    url: 'crm/business_status/type',
    method: 'post',
    data: data
  })
}
// 場景列表
export function crmSceneIndex(data) {
  return request({
    url: 'admin/scene/index',
    method: 'post',
    data: data
  })
}

// 場景建立
export function crmSceneSave(data) {
  return request({
    url: 'admin/scene/save',
    method: 'post',
    data: data
  })
}

// 場景編輯
export function crmSceneUpdate(data) {
  return request({
    url: 'admin/scene/update',
    method: 'post',
    data: data
  })
}

// 場景預設
export function crmSceneDefaults(data) {
  return request({
    url: 'admin/scene/defaults',
    method: 'post',
    data: data
  })
}

// 場景詳情
export function crmSceneRead(data) {
  return request({
    url: 'admin/scene/read',
    method: 'post',
    data: data
  })
}

// 場景刪除
export function crmSceneDelete(data) {
  return request({
    url: 'admin/scene/delete',
    method: 'post',
    data: data
  })
}

// 場景排序
export function crmSceneSort(data) {
  return request({
    url: 'admin/scene/sort',
    method: 'post',
    data: data
  })
}

// 列表欄位排序數據
export function crmFieldConfigIndex(data) {
  return request({
    url: 'admin/field/configIndex',
    method: 'post',
    data: data
  })
}

// 列表排序編輯
export function crmFieldConfig(data) {
  return request({
    url: 'admin/field/config',
    method: 'post',
    data: data
  })
}

// 列表寬度設定
export function crmFieldColumnWidth(data) {
  return request({
    url: 'admin/field/columnWidth',
    method: 'post',
    data: data
  })
}

// 跟進記錄列表
export function crmRecordIndex(data) {
  return request({
    url: 'admin/record/index',
    method: 'post',
    data: data
  })
}

// 跟進記錄新增
export function crmRecordSave(data) {
  return request({
    url: 'admin/record/save',
    method: 'post',
    data: data
  })
}

// 跟進記錄刪除
export function crmRecordDelete(data) {
  return request({
    url: 'admin/record/delete',
    method: 'post',
    data: data
  })
}

// 操作記錄
export function crmIndexFieldRecord(data) {
  return request({
    url: 'admin/index/fieldRecord',
    method: 'post',
    data: data
  })
}

/**
 * 記錄型別 數據 與系統設定系統(repeat)
 * @param {*} data
 */
export function crmSettingRecordListAPI(data) {
  return request({
    url: 'crm/setting/recordList',
    method: 'post',
    data: data
  })
}

// 客戶管理下 合同審批資訊
export function crmExamineFlowStepList(data) {
  return request({
    url: 'admin/examine_flow/stepList',
    method: 'post',
    data: data
  })
}

/**
 * 審批記錄
 * @param {*} data
 * types
 * types_id
 */
export function crmExamineFlowRecordList(data) {
  return request({
    url: 'admin/examine_flow/recordList',
    method: 'post',
    data: data
  })
}

/**
 * 合同審批人資訊
 * @param {*} data
 * types crm_contract
 */
export function crmExamineFlowUserList(data) {
  return request({
    url: 'admin/examine_flow/userList',
    method: 'post',
    data: data
  })
}

/**
 * 相關團隊列表
 * @param {*} data
 * types crm_leads
 * types_id 分類ID
 */
export function crmSettingTeam(data) {
  return request({
    url: 'crm/setting/team',
    method: 'post',
    data: data
  })
}

/**
 * 相關團隊建立
 * @param {*} data
 * types crm_leads
 * types_id 分類ID
 */
export function crmSettingTeamSave(data) {
  return request({
    url: 'crm/setting/teamSave',
    method: 'post',
    data: data
  })
}

/**
 * 獲取匯入描述資訊
 * @param {*} data
 * type crm_leads
 */
export function adminFieldUniqueFieldAPI(data) {
  return request({
    url: 'admin/field/uniqueField',
    method: 'post',
    data: data
  })
}

/**
 * 查重
 * @param {*} data
 * types crm_leads crm_customer
 */
export function crmIndexSearchAPI(data) {
  return request({
    url: 'crm/index/search',
    method: 'post',
    data: data
  })
}
